"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACartesian2dUserTransform = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Provides a user transform that assumes maxes and mins will remain extrema.
 */
class ACartesian2dUserTransform {
    constructor() {
        this.changeId = rc_js_util_1._Identifier.getNextIncrementingId();
    }
    updateTransform(xTransformEnabled, yTransformEnabled) {
        this.xTransformEnabled = xTransformEnabled;
        this.yTransformEnabled = yTransformEnabled;
        this.changeId = rc_js_util_1._Identifier.getNextIncrementingId();
    }
    forwardTransformRange(range, result = range.slice()) {
        result[0] = this.forwardX(range[0]);
        result[1] = this.forwardX(range[1]);
        result[2] = this.forwardY(range[2]);
        result[3] = this.forwardY(range[3]);
        return result;
    }
    forwardTransformPoint(range, result = range.slice()) {
        result[0] = this.forwardX(range[0]);
        result[1] = this.forwardY(range[1]);
        return result;
    }
    reverseTransformRange(range, result = range.slice()) {
        result[0] = this.reverseX(range[0]);
        result[1] = this.reverseX(range[1]);
        result[2] = this.reverseY(range[2]);
        result[3] = this.reverseY(range[3]);
        return result;
    }
    reverseTransformPoint(range, result = range.slice()) {
        result[0] = this.reverseX(range[0]);
        result[1] = this.reverseY(range[1]);
        return result;
    }
}
exports.ACartesian2dUserTransform = ACartesian2dUserTransform;
//# sourceMappingURL=a-cartesian2d-user-transform.js.map